/* eslint-disable @typescript-eslint/switch-exhaustiveness-check */
import type { Settings } from '@velasca/types'

type Subsidiary = 1 | 2 | 5 | 8 | 9

/**
 * It returns the subsidiary number relative to the storefront of a particular nation.
 * If the nation is not a Velasca store, it returns 1.
 *
 * @param storeNation - The shortcode of the nation of the subject store.
 * @returns The subsidiary number.
 */
export const getSubsidiary = (
  storeNation: Settings['store_nation'],
): Subsidiary => {
  if (!storeNation) {
    console.warn(`StoreNation not found in the theme.`)
  }

  switch (storeNation) {
    case 'uk': {
      return 5
    }
    case 'fr': {
      return 2
    }
    case 'de': {
      return 9
    }
    case 'us': {
      return 8
    }
    default: {
      return 1
    }
  }
}
